<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--team-user-profile">
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title">
          <div class="c-title__text c-title__text--blue u-fs34">個人設定</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-team-user-profile">
          <div class="c-title">
            <div class="c-title__text">ログイン情報設定</div>
          </div>
          <ul class="p-team-user-profile-list">
            <profile-login-id :initial-mail="initialMail" />
            <profile-name :initial-name="initialName" />
            <profile-password />
          </ul>
        </div>
      </div>
    </main>
  </div>
  <!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    initialName: String,
    initialMail: String,
  },
  mounted: function() {},
}
</script>
